import React, { FunctionComponent, ReactElement } from 'react';
import { Card } from 'react-bootstrap';

const Forbidden: FunctionComponent<any> = (props: any): ReactElement => {
    return (
        <div data-testid='forbidden-container'>
            <Card className='align-center'>
                <Card.Body>
                    <h1 className='forbidden'>403</h1>
                    <Card.Text>
                        Sorry, you are not authorized to access this page.
                    </Card.Text>
                </Card.Body>
            </Card>
        </div>
    )
}

export default Forbidden;
